var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"items-container__item item",class:{ 'add-new-item': _vm.item.isNewRoute },attrs:{"to":_vm.item.isNewRoute ? { name: 'add-map' } : { name: 'map', params: {id: _vm.item.id}}}},[_c('div',{staticClass:"item__row item__title"},[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e99ffd4","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/ListItemTemplate.vue
// module id = 1464
// module chunks = 65